export enum ReturnError {
    PartNotFound = "PartNotFound",
    ItemNotReturnable = "ItemNotReturnable",
    LineItemMinimumAmount = "LineItemMinimumAmount",
    ReturnTotalMinimumAmount = "ReturnTotalMinimumAmount",
    ItemOutsideReturnWindow = "ItemOutsideReturnWindow",
    DuplicateItemEntry = "DuplicateItemEntry",
    ExceedsMaAuthorizedAmount = "ExceedsMaAuthorizedAmount",
    ExceedsRpAuthorizedAmount = "ExceedsRpAuthorizedAmount",
    InvoiceNotFound = "InvoiceNotFound",
    ItemIsMadeAsOrdered = "ItemIsMadeAsOrdered",
    CurrencyMismatch = "CurrencyMismatch",
    SubmitDatePassed = "SubmitDatePassed",
    MinimumOrderQuantityNotMet = "MinimumOrderQuantityNotMet"
}
